<template>
	<div class="u-container">
		<ReservationAppForm v-if="page === 1" @nextPage="nextPage" />
		<ReservationAppResult v-if="page === 2" />
	</div>
</template>

<script>
import ReservationAppForm from './ReservationAppForm';
import ReservationAppResult from './ReservationAppResult';

import accessRegularUserOnly from '@/mixins/accessRegularUserOnly';
import page from '@/mixins/page';

export default {
	components: {
		ReservationAppForm,
		ReservationAppResult,
	},
	mixins: [accessRegularUserOnly, page],
	data() {
		return {
			noAccessMessage:
				'어플을 통한 예약은\n하이모 정회원부터 이용 가능합니다.\n정회원 전환하기 완료 후 이용해주세요.',
		};
	},
};
</script>
